export const IDLE = "idle";
export const IDLE_2 = "idle2";
export const SLIDE = "slide";
export const RUN = "run";
export const CROUCH = "crouch";
export const ATTACK = "attack";
export const ATTACK_2 = "attack2";
export const ATTACK_3 = "attack3";
export const ATTACK_4 = "attack4";
export const ATTACK_5 = "attack5";
export const ATTACK_6 = "attack6";
export const JUMP = "jump";
export const JUMP_2 = "jump2";
export const RIGHT = "right";
export const LEFT = "left";
